import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridModule } from "@progress/kendo-angular-grid";
import { PipesModule } from "./pipes.module";

// directives
import { ConfirmationScreenComponent } from "../components/confirmation-screen/confirmation-screen.component";
import { ConfirmPopupComponent } from "../components/confirm-popup/confirm-popup.component";
import { RegisterJoinCommitteeComponent } from "../components/register-join-committee/register-join-committee.component";
import { CurrentCommitteeInformationComponent } from "../components/current-committee-information/current-committee-information.component";
import { CurrentCommitteeOfficerInformationComponent } from "../components/current-committee-officer-information/current-committee-officer-information.component";
import { ModifyComponent } from "../components/modify/modify.component";
import { CurrentCommitteeComponent } from "../components/current-committee/current-committee.component";
import { CampaignExpenditureComponent } from "../components/campaign-expenditure/campaign-expenditure.component";
import { FefQualifyingContributionsComponent } from "../components/fef-qualifying-contributions/fef-qualifying-contributions.component";
import { InKindContributionsComponent } from "../components/in-kind-contributions/in-kind-contributions.component";
import { MonetaryContributionsComponent } from "../components/monetary-contributions/monetary-contributions.component";
import { NavigationModule } from "@progress/kendo-angular-navigation";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { MenusModule } from "@progress/kendo-angular-menu";
import { FilingNotesComponent } from "../components/filing-notes/filing-notes.component";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { LabelModule } from "@progress/kendo-angular-label";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { DatePickerModule } from "@progress/kendo-angular-dateinputs";
import { ChartModule } from "@progress/kendo-angular-charts";
import { IconsModule } from "@progress/kendo-angular-icons";
import { UploadsModule } from "@progress/kendo-angular-upload";
import { AppFooter } from "../components/app-footer/app-footer.component";
import { UniqueDropDownFilterComponent } from "../gridfilters/unique-drop-down-filter/unique-drop-down-filter.component";
import { DialogModule, WindowModule } from "@progress/kendo-angular-dialog";
import { SearchContactBoxComponent } from "../components/search-contact/search-contact-box.component";
import { CommitteeSummaryComponent } from "../components/committee-summary/committee-summary.component";
import { TooltipModule } from "./tooltip.module";
import { SectionHeadingModule } from "./section-heading.module";
import { AttachmentDisplayModule } from "./attachment-display.module";
import { TranslocoModule } from "@jsverse/transloco";
import { ContactUpdateCheckComponent } from "../components/contact-update-check/contact-update-check.component";

@NgModule({
    declarations: [
        AppFooter,
        FefQualifyingContributionsComponent,
        InKindContributionsComponent,
        MonetaryContributionsComponent,
        ConfirmationScreenComponent,
        ConfirmPopupComponent,
        RegisterJoinCommitteeComponent,
        CurrentCommitteeInformationComponent,
        CurrentCommitteeOfficerInformationComponent,
        ModifyComponent,
        CurrentCommitteeComponent,
        CampaignExpenditureComponent,
        FilingNotesComponent,
        UniqueDropDownFilterComponent,
        SearchContactBoxComponent,
        CommitteeSummaryComponent,
        ContactUpdateCheckComponent,
    ],
    imports: [
        PipesModule,
        DialogModule,
        NavigationModule,
        DateInputsModule,
        DatePickerModule,
        MenusModule,
        DropDownsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        LayoutModule,
        LabelModule,
        ButtonsModule,
        ListViewModule,
        InputsModule,
        IconsModule,
        UploadsModule,
        TooltipModule,
        DropDownsModule,
        ChartModule,
        WindowModule,
        SectionHeadingModule,
        AttachmentDisplayModule,
        TranslocoModule,
    ],
    exports: [
        PipesModule,
        AppFooter,
        WindowModule,
        FefQualifyingContributionsComponent,
        InKindContributionsComponent,
        MonetaryContributionsComponent,
        IconsModule,
        UploadsModule,
        GridModule,
        LayoutModule,
        InputsModule,
        ButtonsModule,
        LabelModule,
        DateInputsModule,
        DatePickerModule,
        DropDownsModule,
        ChartModule,
        TooltipModule,
        ListViewModule,
        SectionHeadingModule,
        AttachmentDisplayModule,
        ConfirmationScreenComponent,
        RegisterJoinCommitteeComponent,
        CurrentCommitteeInformationComponent,
        CurrentCommitteeOfficerInformationComponent,
        ModifyComponent,
        CurrentCommitteeComponent,
        CampaignExpenditureComponent,
        FilingNotesComponent,
        UniqueDropDownFilterComponent,        
        SearchContactBoxComponent,
        CommitteeSummaryComponent
    ],
})
export class SharedModule {}
